import ws from '../utils/ws';

/* Actions */

export const integrationPartnerPaginatedList = (
  pageNumber,
  pageSize
) => dispatch =>
  dispatch({
    type: INTEGRATION_PARTNERS_PAGINATED_LIST,
    payload: ws.get(
      `/integration_partners/page/${pageNumber}/rows/${pageSize}`
    )
  });

export const integrationPartnerValueUpdate = values => dispatch =>
  dispatch({
    type: CREATE_INTEGRATION_PARTNER_VALUE_UPDATE,
    payload: values
  });

export const integrationPartnerValueReset = () => dispatch =>
  dispatch({
    type: CREATE_INTEGRATION_PARTNER_VALUE_RESET
  });

export const saveIntegrationPartner = partner => dispatch =>
  dispatch({
    type: SAVE_INTEGRATION_PARTNER,
    payload: ws.post('/integration_partners/', partner)
  });

export const deleteIntegrationPartner = partner => dispatch =>
  dispatch({
    type: DELETE_INTEGRATION_PARTNER,
    payload: ws.post(`/integration_partners/${partner.id}/delete`)
  });

export const editIntegrationPartner = id => dispatch =>
  dispatch({
    type: EDIT_INTEGRATION_PARTNER,
    payload: ws.get(`/integration_partners/${id}`)
  });

export const findIntegrationPartners = () => dispatch =>
  dispatch({
    type: FIND_INTEGRATION_PARTNERS,
    payload: ws.get('/integration_partners/')
  });

export const findIntegrationPartner = id => dispatch =>
  dispatch({
    type: FIND_INTEGRATION_PARTNER,
    payload: ws.get(`/integration_partners/${id}`)
  });

export const findIntegrationPartnerVenues = id => dispatch =>
  dispatch({
    type: FIND_INTEGRATION_PARTNER_VENUES,
    payload: ws.get(`/integration_partners/${id}/venues/`)
  });

export const addIntegrationPartnerApiClientId = () => dispatch =>
  dispatch({
    type: ADD_INTEGRATION_PARTNER_API_CLIENT_ID
  });

export const removeIntegrationPartnerApiClientId = index => dispatch =>
  dispatch({
    type: REMOVE_INTEGRATION_PARTNER_API_CLIENT_ID,
    payload: index
  });

export const setIntegrationPartnerApiClientIdValue = (value, index) => dispatch =>
  dispatch({
    type: SET_INTEGRATION_PARTNER_API_CLIENT_ID_VALUE,
    payload: { value, index }
  });

/* Constants */

export const INTEGRATION_PARTNERS_PAGINATED_LIST =
  'INTEGRATION_PARTNERS_PAGINATED_LIST';
export const INTEGRATION_PARTNERS_PAGINATED_LIST_PENDING =
  'INTEGRATION_PARTNERS_PAGINATED_LIST_PENDING';
export const INTEGRATION_PARTNERS_PAGINATED_LIST_FULFILLED =
  'INTEGRATION_PARTNERS_PAGINATED_LIST_FULFILLED';

export const CREATE_INTEGRATION_PARTNER_VALUE_UPDATE =
  'CREATE_INTEGRATION_PARTNER_VALUE_UPDATE';
export const CREATE_INTEGRATION_PARTNER_VALUE_RESET =
  'CREATE_INTEGRATION_PARTNER_VALUE_RESET';

export const SAVE_INTEGRATION_PARTNER = 'SAVE_INTEGRATION_PARTNER';
export const SAVE_INTEGRATION_PARTNER_PENDING =
  'SAVE_INTEGRATION_PARTNER_PENDING';
export const SAVE_INTEGRATION_PARTNER_FULFILLED =
  'SAVE_INTEGRATION_PARTNER_FULFILLED';

export const DELETE_INTEGRATION_PARTNER = 'DELETE_INTEGRATION_PARTNER';
export const DELETE_INTEGRATION_PARTNER_FULFILLED =
  'DELETE_INTEGRATION_PARTNER_FULFILLED';

export const EDIT_INTEGRATION_PARTNER = 'EDIT_INTEGRATION_PARTNER';
export const EDIT_INTEGRATION_PARTNER_FULFILLED =
  'EDIT_INTEGRATION_PARTNER_FULFILLED';

export const FIND_INTEGRATION_PARTNERS = 'FIND_INTEGRATION_PARTNERS';
export const FIND_INTEGRATION_PARTNERS_PENDING =
  'FIND_INTEGRATION_PARTNERS_PENDING';
export const FIND_INTEGRATION_PARTNERS_FULFILLED =
  'FIND_INTEGRATION_PARTNERS_FULFILLED';

export const FIND_INTEGRATION_PARTNER = 'FIND_INTEGRATION_PARTNER';
export const FIND_INTEGRATION_PARTNER_PENDING =
  'FIND_INTEGRATION_PARTNER_PENDING';
export const FIND_INTEGRATION_PARTNER_FULFILLED =
  'FIND_INTEGRATION_PARTNER_FULFILLED';

export const FIND_INTEGRATION_PARTNER_VENUES =
  'FIND_INTEGRATION_PARTNER_VENUES';
export const FIND_INTEGRATION_PARTNER_VENUES_PENDING =
  'FIND_INTEGRATION_PARTNER_VENUES_PENDING';
export const FIND_INTEGRATION_PARTNER_VENUES_FULFILLED =
  'FIND_INTEGRATION_PARTNER_VENUES_FULFILLED';

export const ADD_INTEGRATION_PARTNER_API_CLIENT_ID =
  'ADD_INTEGRATION_PARTNER_API_CLIENT_ID';
export const REMOVE_INTEGRATION_PARTNER_API_CLIENT_ID =
  'REMOVE_INTEGRATION_PARTNER_API_CLIENT_ID';
export const SET_INTEGRATION_PARTNER_API_CLIENT_ID_VALUE =
  'SET_INTEGRATION_PARTNER_API_CLIENT_ID_VALUE';
